import BaseUseCase from "../../../base_use_case.js";

class CreateMemberUseCase extends BaseUseCase {

  execute(params) {

    return this.httpClient({
      ...this.requestConfig(),
      method: "post",
      url: "/api/v1/admin/companies/members",
      data: this.wrapParams(params, "member"),
    });
  }
}

const instance = new CreateMemberUseCase();
export default instance;